import API from '../../sunwiseAPI';

const ENTITY = 'historical-document';

export const uploadDocument = (aftersales_project_configuration, file) =>
    API.post(`/api/v1/${ENTITY}/sunpay/`, {
        aftersales_project_configuration,
        file,
    });
